export interface ParsedBranchResponse {
  visible: string;
  options: string[];
}

export function parseBranchOptions(raw: string): ParsedBranchResponse {
  const options: string[] = [];
  const visible = raw
    .replace(/<branches\b[^>]*>([\s\S]*?)<\/branches>/gi, (_all, body: string) => {
      for (const match of body.matchAll(/<branch\b[^>]*>([\s\S]*?)<\/branch>/gi)) {
        const value = match[1]?.replace(/<[^>]+>/g, "").trim();
        if (value && !options.includes(value)) options.push(value);
      }
      if (!options.length) {
        for (const line of body.split(/\r?\n/)) {
          const value = line.replace(/^\s*(?:[-*]|\d+[.)])\s*/, "").trim();
          if (value && !options.includes(value)) options.push(value);
        }
      }
      return "";
    })
    .trim();
  return { visible, options: options.slice(0, 6) };
}
